module.exports = __webpack_public_path__ + "img/resized-APP-0004-1.2a6bdca6.png";